import React from 'react';
import { ReactComponent as AlertFill } from 'src/assets/icons/alertFill.svg';
import { ReactComponent as TickCircle } from 'src/assets/icons/circleTick.svg';
import { ReactComponent as InfoCircle } from 'src/assets/icons/infoCircle.svg';
import { ReactComponent as WarningCircle } from 'src/assets/icons/warningCircle.svg';

export const getIconForVariant = (variant: string) => {
  switch (variant) {
    case 'success':
      return <TickCircle />;
    case 'error':
      return <AlertFill />;
    case 'info':
      return <InfoCircle />;
    case 'warning':
      return <WarningCircle />;
    default:
      return null;
  }
};
